import { ArrowRight } from "lucide-react";
import PhoneDemo from "./PhoneDemo";

export default function Hero() {
  return (
    <section id="inicio" className="hero">
      <div className="wrap hero-inner">
        <h1 className="display lines">
          <span className="line">
            <span data-line style={{ "--i": 0 }}>Suas vendas a prazo,</span>
          </span>
          <span className="line">
            <span data-line style={{ "--i": 1 }}>recebidas à vista.</span>
          </span>
        </h1>
        <div className="after-lines">
          <p className="hero-sub">
            Antecipamos duplicatas, cheques e contratos e financiamos matéria-prima, com operação
            100% digital e atendimento direto. Em Curitiba, desde 2019.
          </p>
          <div className="hero-actions">
            <a href="#contato" className="btn">
              Fale com a gente
              <ArrowRight size={18} aria-hidden="true" />
            </a>
            <a href="#servicos" className="btn btn-light">
              Conheça os serviços
            </a>
          </div>
        </div>
        <PhoneDemo />
      </div>
    </section>
  );
}
